(() => {
  const init = (scope = document) => {
    scope.querySelectorAll('[data-nwp]').forEach((root) => {
      if (root.dataset.nwpReady) return;
      root.dataset.nwpReady = 'true';
      const picker = root.querySelector('[data-nwp-variant]');
      const quantity = root.querySelector('[data-nwp-quantity]');
      const button = root.querySelector('[data-nwp-add]');
      const form = root.querySelector('.nwp-form');
      const price = root.querySelector('[data-nwp-price]');
      const compare = root.querySelector('[data-nwp-compare]');
      const status = root.querySelector('[data-nwp-status]');
      const image = root.querySelector('.nwp-photo');
      const thumbnails = [...root.querySelectorAll('[data-nwp-thumbnail]')];
      const previewOnly = root.dataset.previewOnly === 'true';
      const optionGroups = [...root.querySelectorAll('[data-nwp-option-position]')];
      const optionPickers = root.querySelector('[data-nwp-option-pickers]');
      const variants = [...picker?.options || []];
      if (!picker || !quantity || !button || !form) return;
      const showImage = (src, alt, imageId) => {
        if (!image || !src) return;
        image.removeAttribute('srcset');
        if (image.hasAttribute('data-worlds-image-main')) {
          const original = new URL(src, window.location.href);
          ['width', 'height', 'crop', 'pad', 'scale'].forEach((key) => original.searchParams.delete(key));
          image.src = src;
          image.dataset.zoomOriginal = original.href;
        } else image.src = src;
        image.alt = alt || '';
        image.dispatchEvent(new CustomEvent('worlds:image-change', { bubbles: true }));
        thumbnails.forEach((thumbnail) => {
          const selected = thumbnail.dataset.imageId === imageId;
          thumbnail.classList.toggle('is-selected', selected);
          if (selected) thumbnail.setAttribute('aria-current', 'true');
          else thumbnail.removeAttribute('aria-current');
        });
      };
      const syncVariant = (updateUrl) => {
        const selected = picker.selectedOptions[0];
        const available = Boolean(!previewOnly && selected && selected.dataset.available === 'true' && !selected.disabled);
        button.disabled = !available;
        quantity.disabled = !available;
        const accelerated = root.querySelector('[data-nwp-accelerated]');
        if (accelerated) accelerated.hidden = !available;
        button.textContent = previewOnly ? root.dataset.previewLabel : available ? root.dataset.addLabel : root.dataset.unavailableLabel;
        status.textContent = previewOnly ? root.dataset.previewNote : available ? root.dataset.availableLabel : root.dataset.unavailableNote;
        if (!selected) return;
        optionGroups.forEach((group) => {
          const value = selected.getAttribute(`data-option-${Number(group.dataset.nwpOptionPosition) + 1}`);
          group.querySelectorAll('[data-nwp-option-value]').forEach((input) => { input.checked = input.value === value; });
          const label = group.querySelector('[data-nwp-option-label]');
          if (label) label.textContent = value || '';
        });
        price.textContent = selected.dataset.price || '';
        compare.textContent = selected.dataset.compare || '';
        compare.hidden = selected.dataset.onSale !== 'true';
        quantity.min = selected.dataset.quantityMin || '1';
        quantity.step = selected.dataset.quantityStep || '1';
        if (selected.dataset.quantityMax) quantity.max = selected.dataset.quantityMax;
        else quantity.removeAttribute('max');
        if (!quantity.checkValidity()) quantity.value = quantity.min;
        if (updateUrl) {
          showImage(selected.dataset.image, selected.dataset.imageAlt, selected.dataset.imageId);
          const url = new URL(window.location.href);
          url.searchParams.set('variant', selected.value);
          window.history.replaceState({}, '', url);
        }
      };
      picker.addEventListener('change', () => syncVariant(true));
      if (optionGroups.length && optionPickers) {
        optionGroups.forEach((group) => group.addEventListener('change', () => {
          const values = optionGroups.map((item) => ({ position: Number(item.dataset.nwpOptionPosition) + 1, value: item.querySelector('[data-nwp-option-value]:checked')?.value }));
          const match = variants.find((variant) => values.every(({ position, value }) => variant.getAttribute(`data-option-${position}`) === value));
          if (match) picker.value = match.value;
          else picker.selectedIndex = -1;
          syncVariant(true);
        }));
        optionPickers.hidden = false;
        root.classList.add('nwp-enhanced');
      }
      thumbnails.forEach((thumbnail) => thumbnail.addEventListener('click', (event) => {
        if (!image || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        const current = picker.selectedOptions[0];
        const matches = variants.filter((variant) => variant.dataset.imageId === thumbnail.dataset.imageId);
        const match = matches.find((variant) => variant.getAttribute('data-option-2') === current?.getAttribute('data-option-2')) || matches[0];
        if (match) { picker.value = match.value; syncVariant(true); }
        showImage(thumbnail.dataset.imageSrc, thumbnail.dataset.imageAlt, thumbnail.dataset.imageId);
      }));
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (form.dataset.submitting === 'true') return;
        const selected = picker.selectedOptions[0];
        if (previewOnly || !selected || selected.disabled || selected.dataset.available !== 'true') {
          status.textContent = root.dataset.unavailableNote;
          button.disabled = true;
          return;
        }
        if (!quantity.checkValidity()) {
          status.textContent = root.dataset.quantityError;
          quantity.reportValidity();
          return;
        }
        form.dataset.submitting = 'true';
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        button.textContent = 'Adding…';
        try {
          const response = await fetch(form.action.replace(/\/cart\/add$/, '/cart/add.js'), {
            method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form)
          });
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || result.message || 'This item could not be added. Please try again.');
          window.location.assign(root.dataset.cartUrl || '/cart');
        } catch (error) {
          status.textContent = error.message || 'This item could not be added. Please try again.';
          status.setAttribute('role', 'alert');
          button.disabled = false;
          button.textContent = root.dataset.addLabel;
        } finally {
          delete form.dataset.submitting;
          button.removeAttribute('aria-busy');
        }
      });
      syncVariant(false);
    });
    scope.querySelectorAll('[data-nwc]').forEach((root) => {
      if (root.dataset.nwcReady) return;
      root.dataset.nwcReady = 'true';
      const notice = root.querySelector('[data-nwc-notice]');
      if (root.dataset.previewOnly === 'true') {
        const checkout = root.querySelector('.nwc-checkout');
        if (checkout) { checkout.disabled = true; checkout.type = 'button'; checkout.removeAttribute('name'); }
        root.querySelector('.nwc-form')?.addEventListener('submit', (event) => {
          if (event.submitter?.name === 'checkout') event.preventDefault();
        });
      }
      root.querySelectorAll('[data-nwc-quantity]').forEach((input) => {
        input.addEventListener('input', () => {
          if (notice) {
            notice.textContent = root.dataset.quantityChanged || '';
            notice.hidden = false;
          }
        });
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
